import { render, staticRenderFns } from "./UserDetail_Button_Fans.vue?vue&type=template&id=2123e836&"
import script from "./UserDetail_Button_Fans.vue?vue&type=script&lang=js&"
export * from "./UserDetail_Button_Fans.vue?vue&type=script&lang=js&"
import style0 from "./UserDetail_Button_Fans.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports